export const ADMIN_NAV_ITEMS = [
  {
    key: 'home',
    label: '\u76f4\u64ad\u7ba1\u7406',
    route: '/',
    icon: 'grid',
  },
  {
    key: 'promotion',
    label: '\u63a8\u5e7f\u7ba1\u7406',
    route: '/promotion',
    icon: 'megaphone',
  },
  {
    key: 'notifications',
    label: '\u7ad9\u5185\u4fe1',
    route: '/notifications',
    icon: 'bell',
    adminOnly: true,
  },
  {
    key: 'customer-service',
    label: '\u5ba2\u670d\u8bbe\u7f6e',
    route: '/customer-contact',
    icon: 'message',
  },
  {
    key: 'visits',
    label: '\u8bbf\u95ee\u8bb0\u5f55',
    route: '/visitsTable',
    icon: 'pulse',
  },
  {
    key: 'bigscreen',
    label: '\u6570\u636e\u5927\u5c4f',
    route: '/BigScreen',
    icon: 'chart',
  },
  {
    key: 'control',
    label: '\u76f4\u64ad\u4e2d\u63a7',
    route: '/streamer-agora',
    icon: 'gear',
  },
  {
    key: 'overview',
    label: '\u76f4\u64ad\u603b\u89c8',
    route: '/live-overview',
    icon: 'layers',
  },
  {
    key: 'reply',
    label: '\u76f4\u64ad\u56de\u590d',
    route: '/live-reply',
    icon: 'message',
  },
  {
    key: 'settings',
    label: '\u8bbe\u7f6e\u4e2d\u5fc3',
    route: '/settings',
    icon: 'sliders',
  },
]

export function findAdminNavItemByRoute(path) {
  return ADMIN_NAV_ITEMS.find((item) => item.route === path) || ADMIN_NAV_ITEMS[0]
}
